var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-transfer',{ref:"transfer",attrs:{"filterable":"","filter-placeholder":"请输入关键字","titles":_vm.titles,"data":_vm.data},on:{"change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }